import React from 'react';
import JoinForm from '../Components/JoinForm';
import img1 from '../img/contact/contact.png'

const Contact = () => {
    return (
        <div className='md:px-20 px-5 text-lg'>
            <img className=' w-full my-5 h-[60vh]' src={img1} alt="" />

            <JoinForm id='consultation' title="Book Free Consultation" free />
            <JoinForm id='write-rk' title="Write RK" free write />
        </div>
    );
};

export default Contact;
